<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">{{ $t("kids.createNewKid") }}</p>

            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <InputForm
                  v-model="formData.kid_name"
                  :placeholder="$t('kids.name')"
                  :isRequired="true"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <DatePicker
                  v-model="formData.birthday"
                  :placeholder="$t('kids.birthday')"
                />
              </div>
              <div class="mb-3">
                <InputForm
                  v-model="formData.mobile"
                  :placeholder="$t('teachers.mobile')"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <SelectFormParent
                  @select="setParent"
                  v-model="parents"
                  :isRequired="true"
                  :selectedOption="$t('parents.selectParent')"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0"
                  >({{ $t("global.requiredField") }})</span
                >
                <SelectFormCourse
                  @select="setSubcourse"
                  v-model="subcourses"
                  :isDisabled="!subcourses.length"
                  :isRequired="true"
                  :selectedOption="$t('subcourses.selectSubcourse')"
                />
              </div>
              <div class="mb-3">
                <InputForm
                  v-model="formData.discount"
                  :placeholder="$t('subcourses.discount')"
                  type="text"
                />
              </div>
              <div>
                <label
                  for="file"
                  :v-model="formData.file"
                  class="mx-2 custom-file-upload"
                  ><span>{{ $t("global.uploadImage") }}</span>
                </label>
                <input
                  type="file"
                  id="file"
                  @change="handleFileUpload"
                  accept="image/*"
                />
              </div>
              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.create") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SelectFormParent from "@/components/SelectFormParent.vue";
import SelectFormCourse from "@/components/SelectFormCourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SelectFormCourse,
    SoftButton,
    SoftBadge,
    SelectFormParent,
    DatePicker,
  },
  data() {
    return {
      formData: {
        kid_name: "",
        birthday: "",
        mobile: "",
        discount: "",
        parent_id: null,
        subcourse_ids: [],
      },
      parents: [],
      courses: [],
      subcourses: [],
      selectedFile: "",
      selectedCourse: null,
      selectedSubcourse: null,
      isFirstSelected: false,
      imageUrl: "",
    };
  },
  created() {
    this.getParents();
    this.getSubcourses();
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("kid_name", this.formData.kid_name);
      if (formData.birthday != "") {
        formData.append("birthday", this.formData.birthday);
      }
      if (formData.mobile != "") {
        formData.append("mobile", this.formData.mobile);
      }
      formData.append("parent_id", this.formData.parent_id);
      formData.append("discount", this.formData.discount);
      formData.append("subcourse_id", this.formData.subcourse_ids);
      if (this.selectedFile != "") {
        formData.append("image", this.selectedFile);
      }
      try {
        await axios.post("kid", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.resetForm();
        swal.fire({
          icon: "success",
          title: "Polaznik uspesno kreiran",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("form-submitted", true);
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    async getParents() {
      const response = await axios.get("parents/all");
      this.parents = response.data.parents;
    },
    async getSubcourses() {
      const response = await axios.get("subcourses/all");
      this.subcourses = response.data.subcourses;
    },
    setSubcourse(subcourses) {
      this.formData.subcourse_ids = [subcourses];
    },
    setParent(parent_id) {
      this.formData.parent_id = parent_id;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.selectedFile = file;

      this.imageUrl = URL.createObjectURL(file);
    },
    resetForm() {
      this.formData.kid_name = "";
      this.formData.discount = "";
      this.formData.parent_id = null;
      this.formData.subcourse_ids = [];
      return;
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}
#file {
  display: none;
}
.custom-file-upload span {
  pointer-events: none;
}
.float-right {
  float: right;
}
</style>
